export const AI_SEARCH_RETURN_KEY = 'ai-search-return';
export const REOPEN_HEADER_SEARCH_EVENT = 'reopen-header-search';
export const AI_SEARCH_HISTORY_PARAM = 'history';
export const HEADER_SEARCH_OPEN_PARAM = 'searchState';
